import isNumber from "lodash/fp/isNumber";
import apis from "../../core/apis";
import constants from "../../core/constants";

class Controller {
  constructor(Events, Upload, Sections) {
    "ngInject";

    this.Events = Events;
    this.Upload = Upload;
    this.sections = Sections.settingsSections;
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;

    this.clear = () => {
      delete this.file;
    };

    this.upload = () => {
      if (this.file && isNumber(this.amount) && this.amount > 0) {
        this.isUploading = true;
        const data = {
          userIds: this.file,
          amount: this.amount * constants.currencyBy,
          name: this.name,
          description: this.description,
        };
        if (this.expiryDate) {
          data.expiryDate = this.expiryDate.toISOString();
        }
        this.Upload.upload({
          url: apis.credits,
          data,
        }).then(
          () => {
            this.Events.emit(showNotificationEvent, {
              message: "Your file has been uploaded successfully",
            });
            this.isUploading = false;
            delete this.file;
            delete this.amount;
            delete this.expiryDate;
          },
          (response) => {
            const message = response.data.message || "Can't upload your file !";

            this.Events.emit(errorEvent, { message });
            this.isUploading = false;
          }
        );
      }
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bulkcredits/bulkcredits.controller.js